export const titleCase = (code) => {
    const s = code.replace(/[-_]+/g, " ").trim();
    return s ? s[0].toUpperCase() + s.slice(1) : s;
};
export const shortId = (id) => id.slice(0, 8);
export function formatDateTime(iso) {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}
export function formatDate(date) {
    const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date}T00:00:00` : date);
    return Number.isNaN(d.getTime()) ? date : d.toLocaleDateString(undefined, { dateStyle: "medium" });
}
/** Whole days from `now` to a YYYY-MM-DD date: negative when it is in the past. */
export function daysUntil(date, now = new Date()) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date))
        return null;
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const [y, m, d] = date.split("-").map(Number);
    return Math.round((Date.UTC(y, m - 1, d) - today) / 86_400_000);
}
export const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
